export default __webpack_public_path__ + "b0bcdec7071a3aca3aadfd64205956d8.svg";